export const ShareFeedbackLink = function () {
	if (!document.querySelector(".feedback-link-container")) return false;

	const copyButton = document.querySelector(".copy-feedback-link");
	const whatsappButton = document.querySelector(".share-whatsapp-link");

	// Copy functionality
	if (copyButton) {
		copyButton.addEventListener("click", function () {
			const input = document.querySelector(".feedback-link-input");
			if (input) {
				input.select();
				input.setSelectionRange(0, 99999); // For mobile devices

				try {
					navigator.clipboard.writeText(input.value).then(function () {
						// Change button text temporarily to show success
						const originalText = copyButton.textContent;
						copyButton.textContent = window.CFG.strings.copiedText || "Copied!";
						copyButton.style.backgroundColor = "#28a745";

						setTimeout(function () {
							copyButton.textContent = originalText;
							copyButton.style.backgroundColor = "";
						}, 2000);
					});
				} catch (err) {
					// Fallback for older browsers
					document.execCommand("copy");
					const originalText = copyButton.textContent;
					copyButton.textContent = window.CFG.strings.copiedText || "Copied!";
					copyButton.style.backgroundColor = "#28a745";

					setTimeout(function () {
						copyButton.textContent = originalText;
						copyButton.style.backgroundColor = "";
					}, 2000);
				}
			}
		});
	}

	// WhatsApp share functionality
	if (whatsappButton) {
		whatsappButton.addEventListener("click", function () {
			const input = document.querySelector(".feedback-link-input");
			if (input) {
				const feedbackLink = input.value;
				const messageText =
					whatsappButton.getAttribute("data-message") ||
					window.CFG.strings.shareFeedbackLinkText ||
					"Wil je mij feedback geven?";
				const message = encodeURIComponent(`${messageText} ${feedbackLink}`);

				// Check if user is on mobile device
				const isMobile =
					/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
						navigator.userAgent,
					);

				let whatsappUrl;
				if (isMobile) {
					// Use WhatsApp app URL scheme for mobile devices
					whatsappUrl = `whatsapp://send?text=${message}`;
				} else {
					// Use WhatsApp Web for desktop devices
					whatsappUrl = `https://wa.me/?text=${message}`;
				}

				// Open WhatsApp app or web in new tab
				window.open(whatsappUrl, "_blank");
			}
		});
	}
};
